import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpvxhv8kmp: FaireProductEntity = {
  token: "p_cpvxhv8kmp",
  type: "product",
  name: "Cece Body Butter | Half Case",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/cfa250c4815dd2a26e2917d991adcfc8c5ffb6276030c2d34cbc923a0859193e.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0cda2139c7a222abcfab54cf985efbd7444967f8820f4dae0b3d08fd6e303168.jpeg",
    "https://cdn.faire.com/fastly/1e5f1b5b5d98f324a340654aace65d22037cc1ab10f700f8252308db0a522feb.webp",
    "https://cdn.faire.com/fastly/a289a8050a944bfe68f9afdb20ed556fa2d1628eb11ead528cd07543254bf22f.webp",
  ],
  priceDollars: 31.92,
  description:
    "Pamper your skin with Homecourt’s Cece Body Butter, a rich, velvety cream formulated for intense hydration and infused with our iconic fine fragrance. Designed to deliver deep nourishment and long-lasting moisture, this moisturizing body cream leaves skin smooth, supple, and beautifully scented.\n\nCrafted with skincare-grade ingredients, this luxury body butter combines powerful botanicals with indulgent texture for a treatment that hydrates instantly and lasts up to 72 hours.\n\n𝐖𝐡𝐲 𝐘𝐨𝐮’𝐥𝐥 𝐋𝐨𝐯𝐞 𝐈𝐭\n• Luxury body butter infused with Homecourt’s signature fine fragrance\n• Shea butter to deeply moisturize and condition skin\n• Organic rosella extract for 72-hour hydration\n• Plant-sourced vitamin E delivers antioxidant protection\n• Natural clay minerals leave skin soft and supple\n• Upcycled sugar beet extract provides sustainable, natural moisture\n• Hydrating body cream with a fast-absorbing, non-greasy finish\n\nCece\nCedarwood smoke, cardamom, cinnamon, and white leather. Grounded, mysterious, addictive.\nNotes: Cardamom*, Mate Leaves*, Cinnamon*, Carrot Seed, Patchouli*, Vetiver*\n\n𝐇𝐨𝐰 𝐭𝐨 𝐔𝐬𝐞\n\nMassage onto clean, dry skin until fully absorbed. Use daily for luxurious hydration and lasting fragrance.\n\n𝐒𝐢𝐳𝐞\n\n6.7 fl oz / 200 ml\n\n𝐏𝐚𝐢𝐫𝐢𝐧𝐠 𝐑𝐞𝐜𝐨𝐦𝐦𝐞𝐧𝐝𝐚𝐭𝐢𝐨𝐧\n\nLayer with Homecourt’s Cece Body Wash and Body Mist for a complete luxury body care ritual that hydrates, scents, and refreshes from head to toe.",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:19.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
